let _pyodide: any | null = null;
let _loading: Promise<any> | null = null;

export async function getPyodide() {
  if (_pyodide) return _pyodide;
  if (_loading) return _loading;

  _loading = (async () => {
    if (!(window as any).loadPyodide) {
      await new Promise<void>((resolve, reject) => {
        const s = document.createElement('script');
        s.src = 'https://cdn.jsdelivr.net/pyodide/v0.26.2/full/pyodide.js';
        s.async = true;
        s.onload = () => resolve();
        s.onerror = reject;
        document.head.appendChild(s);
      });
    }
    const pyodide = await (window as any).loadPyodide({
      indexURL: 'https://cdn.jsdelivr.net/pyodide/v0.26.2/full',
    });
    _pyodide = pyodide;
    return pyodide;
  })();

  return _loading;
}
